/*
 *
 * Application Main
 *
 */
!(function(APP) {
    'use strict';


    var breakpoint = 1119;

    $.extend(true, APP, {
        breakpoint: breakpoint,
        init: {
            floatingLabel: () => {

                function change() {
                    var val = $(this).val();
                    $(this)[val ? 'removeClass' : 'addClass']('not-filled');
                }

                $('.form-floating select').on('change', change).each(function() {
                    change.call(this);
                });
            },
            menu: () => {
                var doc = window.document.documentElement,
                    navItems = document.querySelectorAll('.navbar-nav .nav-link'),
                    navToggler = document.querySelector('.navbar-toggler');

                if (!navToggler) {
                    return;
                }

                const activateMenu = (li) => {
                    li.classList.toggle('active');
                    APP.Helper.DOM.getSiblings(li).forEach(sibling => {
                        sibling.classList.remove('active');
                    });
                };

                const menuHandle = (li, event) => {
                    event = event || 'mouseenter';

                    const a = li.querySelector('a');

                    if (APP.browser.mobile) {
                        a.addEventListener('click', () => {
                            activateMenu(li);
                        });
                    } else {
                        (event === 'click' ? a : li).addEventListener(event, () => {
                            activateMenu(li);
                        });

                        li.addEventListener('mouseleave', () => {
                            activateMenu(li);
                        });
                    }
                };

                const childSubMenus = [];
                [...navItems].forEach(el => {
                    const li = el.parentNode;
                    if (el.nextElementSibling && el.nextElementSibling.classList && el.nextElementSibling.classList.contains('submenu-container')) {
                        menuHandle(li);

                        const subMenus = li.querySelectorAll('.menu > li > a');

                        subMenus.forEach(el => {
                            if (el.nextElementSibling && el.nextElementSibling.classList && el.nextElementSibling.classList.contains('sub-menu')) {
                                const lip = el.parentNode;
                                menuHandle(lip, 'click');
                            }
                        });
                    } else {
                        menuHandle(li);
                    }
                    childSubMenus.push(li);
                });

                if (childSubMenus.length === 1 && !1) {
                    childSubMenus[0].addEventListener('mouseleave', () => {
                        childSubMenus[0].classList.remove('active');
                    });
                }

                navToggler.addEventListener('click', () => {
                    doc.classList.toggle('open-menu');

                    if (APP.browser.bp()) {
                        var navbar = document.querySelector('#navbar');
                        var activeItem = $('.navbar-nav .nav-item.active');
                        var scrollLeft = $(navbar).scrollLeft();
                        $(navbar).stop().animate({ scrollLeft: scrollLeft + activeItem.offset().left }, 500);
                    }
                });

                $('.back-to-parent').on('click', function() {
                    $(this).closest('li.active').removeClass('active');
                });
            },
            aside: () => {

                $('.aside-menu > li a').on('click', function(e) {

                    var $this = $(this);

                    if ( $this.next().is('ul') ) {

                        e.preventDefault();
                        $this.next().collapse('toggle');
                        $this.parent().toggleClass('collapsed').find('ul > li').removeClass('active');
                    }
                });

                var list = $('.aside-menu > li .inner-list').clone();
                if (list.length > 0) {
                    list.addClass('aside-menu d-md-none').removeClass('inner-list').find('> li').addClass('collapsed');
                    $('.aside-container').append(list);
                }
            },
            scrollUp: () => {

                $('.scroll-up-btn').on('click', () => {
                    $(document.documentElement).scrollTop(0);
                });
            },
            timeline: () => {
                if (!document.getElementById('timeline-nav')) {
                    return;
                }
                var setDebounce = true;
                var navbar = $('.timeline .navbar');
                new bootstrap.ScrollSpy(document.body, { // eslint-disable-line
                    target: '#timeline-nav',
                    offset: 180
                });

                window.addEventListener('activate.bs.scrollspy', APP.Helper.debounce(function() {

                    if (setDebounce) {

                        var activeItem = $('.timeline .navbar .nav-pills .nav-link.active');
                        if (activeItem.length) {
                            var scrollLeft = navbar.scrollLeft();
                            navbar.stop().animate({ scrollLeft: scrollLeft + activeItem.offset().left }, 500);

                            // var scrollTop = navbar.scrollTop();
                            var offset = activeItem.position().top + activeItem.height();
                            console.log(navbar.height(), offset);
                            if (offset > navbar.height() || offset < 0) {
                                navbar.stop().animate({ scrollTop: activeItem.position().top }, 500);
                            }
                            // navbar.stop().animate({ scrollTop: activeItem.position().top }, 500);
                        }
                    }
                }, 300));

                $('.timeline .navbar .nav-pills .nav-link').on('click', function() {
                    setDebounce = false;

                    $(window).one('scroll', APP.Helper.debounce(function() {
                        setDebounce = true;
                    }, 400));
                });

                /* if (APP.browser.bp()) { // mobile

                    $(window).on('scroll', APP.Helper.throttle(function() {

                        if (setDebounce) {
                            console.log('acrtive scroll');

                            var activeItem = $('.timeline .navbar .nav-pills .nav-link.active');
                            if (activeItem.length) {
                                var scrollLeft = navbar.scrollLeft();
                                navbar.stop().animate({ scrollLeft: scrollLeft + activeItem.offset().left }, 500);
                            }
                        }
                    }, 300));
                } */
            },
            stickyHeader: () => {
                var header = $('#header'),
                    scrollTop = 16;

                var control = APP.Helper.throttle(function() {
                    if (window.scrollY > scrollTop) {
                        if (!header.hasClass('sticky')) {
                            header.addClass('sticky');
                        }
                    } else {
                        header.removeClass('sticky');
                    }
                }, 300);

                window.addEventListener('scroll', control);
            },
            videoPlayer: () => {

                function playFn(video, play, context) {
                    video.currentTime = 0;

                    if (APP.browser.ios) {
                        video.autoplay = play;
                        // video.controls = true;
                    }
                    video[play ? 'play' : 'pause']();
                    var btn = $(video).parents(context || '.slick-slide').find('.see-video');
                    btn[play ? 'addClass' : 'removeClass']('fade');
                }

                function videoPlay(play, slider, currentSlide, context, s) {
                    var slide = s || slider.find(context || '.slick-slide:not(.slick-cloned)').eq(currentSlide);
                    var $video = slide.find('video');

                    if ($video.length) {
                        playFn($video[0], play, context);
                    }
                }

                var slider = $('[data-slick-type="main"]');

                videoPlay(true, slider, 0, '.content');

                $('.see-video').on('click', function() {
                    var $this = $(this);
                    var $video = $this.closest('.slick-slide').find('video');

                    if ($video.length) {
                        playFn($video[0], true);
                    }
                });

                $('video').on('ended', function (e) {
                    var btn = $(e.target).parents('.slick-slide').find('.see-video');
                    btn.removeClass('fade');
                });

                slider.on('beforeChange', function(event, slick, currentSlide) {
                    var slide = slick.$slides.eq(currentSlide);
                    videoPlay(false, slider, currentSlide, '.content', slide);
                });

                slider.on('afterChange', function(event, slick, currentSlide) {
                    var slide = slick.$slides.eq(currentSlide);
                    videoPlay(true, slider, currentSlide, '.content', slide);
                });
            },
            scrollUps: () => {
                var animationPrams = {
                    from: { opacity: 0 },
                    to: { opacity: 1 },
                    triggerHook: .75
                };
                var controller = new ScrollMagic.Controller(); // eslint-disable-line

                $('[data-scroll="container"]').each(function(i, e) {

                    var items = $(e).find('[data-scroll="scroll"]');

                    items.each(function(i, e) {
                        var el = $(e);
                        var anim = el.data('scroll-anim');
                        var from, to;
                        var triggerHook = 'onCenter';
                        var duration = $(e).data('duration') || '75%';

                        if (duration === 'auto') {
                            duration = $(e).height();
                        }

                        from = animationPrams.from;
                        to = animationPrams.to;
                        triggerHook = animationPrams.triggerHook;

                        triggerHook = $(e).data('hook') || triggerHook;

                        var tween = TweenMax.staggerFromTo(el, 1, from, to, 0.15); // eslint-disable-line
                        var sceneOpts = {
                            triggerElement: e,
                            duration: duration,
                            triggerHook: triggerHook
                        };

                        var offset = $(e).data('offset') || 0;

                        if (offset === 'auto') {
                            offset = $(e).height();
                        }

                        sceneOpts.offset = offset;

                        if (anim !== 'fadeOutUp') {
                            delete sceneOpts.duration;
                        }

                        var scene = new ScrollMagic.Scene(sceneOpts); // eslint-disable-line
                        scene.setClassToggle(e, 'animate__' + anim);
                        e.classList.add('animate__animated');
                        scene.setTween(tween).addTo(controller);
                        if (anim !== 'fadeOutUp') {
                            scene.reverse(false);
                        }

                        if (el.find('.count').length) {
                            scene.on('enter', function() {
                                APP.init._counter(el.find('.count'));
                            });
                        } else if (anim === 'custom') {
                            scene.on('enter', function() {
                                el.addClass('animated');
                            });
                        }
                    });
                });

                /* $(document).on('animationend', '[data-scroll]', function(ev) {
                    ev.target.classList.remove('animate__animated');
                    ev.target.classList.add('animate__finish');
                }); */
            },
            _counter: (el) => {

                function animateValue(obj, start, end, duration) {
                    let startTimestamp = null;

                    const step = (timestamp) => {
                        if (!startTimestamp) {
                            startTimestamp = timestamp;
                        }
                        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                        obj.innerHTML = Math.floor(progress * (end - start) + start);
                        if (progress < 1) {
                            window.requestAnimationFrame(step);
                        }
                    };

                    window.requestAnimationFrame(step);
                }

                el.each(function(i, e) {
                    animateValue(e, 0, e.innerHTML, 2000);
                });
            },
            _mainSlideClass: () => {
                var slider = $('[data-slick-type="main"]');
                slider.find('.content').each(function(i, e) {
                    var el = $(e);
                    el.find('.img img').parent('.img').addClass('only-img');
                });
            },
            search: () => {
                $('.search .btn-toggler').on('click', function() {
                    $('#search').toggleClass('open');
                });
            },
            language: () => {
                var language = $('#navbar > .language');
                var clone = language.clone();
                language.remove();

                clone.appendTo('.submenu-container > .container');
            },
            datepicker: function() {

                $.fn.datepicker.dates.en.format = 'mm.dd.yyyy';
                var settings = {
                    language: UNIGATE.current.language || 'tr',
                    autoclose: true,
                    orientation: 'bottom left',
                    templates: {
                        leftArrow: '<i class="ms-icon ms-icon-arrow-left"></i>',
                        rightArrow: '<i class="ms-icon ms-icon-arrow-right"></i>'
                    }
                };

                var datepickers = $('.date-picker');


                function renderPicker(i, e) {
                    var downIcon = $('<i class="ms-icon ms-icon-arrow-down">'),
                        dateIcon = $('<i class="ms-icon ms-icon-date">');

                    downIcon.insertAfter($(e));
                    dateIcon.insertAfter($(e));

                    var startDate = APP.sanitizeXss($(e).data('start-date')),
                        target = APP.sanitizeXss($(e).data('target')),
                        opts = $.extend({}, settings);

                    if (startDate) {
                        var date = new Date();

                        date.setDate(date.getDate() + startDate);
                        opts.startDate = APP.Helper.getDateFormatted(date);
                    }

                    var api = $(e).datepicker(opts);

                    if (target) {
                        target = $(target);
                        api.on('changeDate', function(event) {
                            var date = event.date;

                            date.setDate(date.getDate() + (APP.sanitizeXss(target.data('start-date')) || 1));
                            target.datepicker('setStartDate', APP.Helper.getDateFormatted(date));
                        });
                    }
                }

                datepickers.each(renderPicker);

                datepickers.on('show', function(e) {
                    var target = $(e.target);

                    $('.datepicker-dropdown').outerWidth(target.parent().width());
                    target.addClass('flat-bottom open');
                }).on('hide', function(e) {
                    var target = $(e.target);

                    target.removeClass('flat-bottom open');
                });
            }
        },

        INIT: function(options) {
            // APP init

            options = options || {};

            var fn;

            for (var i in this.init) {
                if ( Object.prototype.hasOwnProperty.call(this.init, i) && i.charAt(0) !== '_' && typeof(fn = this.init[i]) === 'function' ) {
                    fn.call(this, options && options[i] || options);
                }
            }

            return this;
        }
    });

})(window.APP = window.APP || {});

$(function() {
    'use strict';

    APP.browser = (function() {

        var is = APP.Helper.is,
            val, tmp,
            userAgent = APP.sanitizeXss(navigator.userAgent);

        var browser = {
            mobile: !!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile/i.test(userAgent),
            ios: !!/iPhone|iPad|iPod/i.test(userAgent),
            ie: (tmp = userAgent.toLowerCase().match(/MSIE ([^;]+)|rv:(11)\.[0-9]+/i)) ? parseInt(tmp[1] || tmp[2], 10) : false,
            edge: (tmp = userAgent.indexOf('Edge/')) > 0 ? parseInt(userAgent.substring(tmp + 5, userAgent.indexOf('.', tmp)), 10) : false,
            bp: function() {
                return $(window).width() < APP.breakpoint;
            }
        };

        var $el = $('html'); // document.documentElement

        for (var k in browser ) {
            if ( Object.prototype.hasOwnProperty.call(browser, k) ) {
                val = browser[k];

                if ( val && !is.function(val) ) {
                    $el.addClass(k);
                    if ( !is.boolean(val) ) {
                        $el.addClass(k + val);
                    }
                }
            }
        }

        APP.browser = browser;

        return browser;
    }());

    APP.scriptPath = APP.Helper.getScriptPath(['app.js', 'app.min.js', 'main.js']);

    APP.Helper.loadScript(APP.scriptPath + 'config.js', {
        success: function() {
            APP.INIT(CONFIG);
        },
        failed: function() {
            APP.INIT();
        }
    });
});
